__turbopack_context__.v({
  "chartContainer": "traceChart-module-scss-module__D-2LHW__chartContainer",
  "tooltipRow": "traceChart-module-scss-module__D-2LHW__tooltipRow",
  "tooltipWrapper": "traceChart-module-scss-module__D-2LHW__tooltipWrapper",
  "wrapper": "traceChart-module-scss-module__D-2LHW__wrapper",
});
